import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  server: {},

  clientPrefix: 'VITE_',

  client: {
    VITE_APP_TITLE: z.string().min(1).optional(),
    VITE_API_BASE_URL: z.url(),
    VITE_API_STORAGE_BASE_URL: z.url(),
    VITE_SENTRY_DSN: z.string().url().optional(),
  },

  runtimeEnv: import.meta.env,

  emptyStringAsUndefined: true,
});
